function generateMutations() {
    return {
        SET_ERROR(state, payload) {
            state.orderError = payload
        },
        SET_ORDER(state, payload) {
            state.order = payload
        },
        SET_RESTAURANT(state, payload) {
            state.restaurant = payload
        },
        SET_TRACK_ORDER(state, payload) {
            state.trackOrder = payload
        },
        SET_DELIVERY_JOB(state, payload) {
            const deliveryJob =
                payload?.trackOrder?.isCanteenSubOrder && payload?.trackOrder?.canteenMasterOrder
                    ? payload?.trackOrder?.canteenMasterOrder.deliveryJob
                    : payload?.trackOrder?.deliveryJob ||
                      payload?.order?.deliveryJob ||
                      payload?.order?.delivery_job

            if (deliveryJob) state.deliveryJob = deliveryJob
        },
        SET_DELIVERY_STATUS(state, deliveryJob) {
            const deliveryStatus = deliveryJob.courierStatus || deliveryJob.courier_status
            if (deliveryStatus) state.deliveryStatus = deliveryStatus
        },
        SET_UPDATE_STATUS(state, payload) {
            state.waitingForUpdate = payload
        },
        TICK(state, now) {
            state.now = now || Date.now()
        },
        RESET_DELIVERY_STATUS(state) {
            state.order = {}
            state.trackOrder = {}
            state.deliveryJob = {}
            state.deliveryStatus = null
            state.orderError = false
            state.waitingForUpdate = false
        },
    }
}

export default generateMutations
